import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { getStageForPath } from './adminNav';
import useWorkshopChain from '../../hooks/useWorkshopChain';
import useInstanceRecord from '../../hooks/useInstanceRecord';
import { currentStage } from '../../utils/stageStatus';

/**
 * What both header rows need to know about the stages
 * (specs/admin-instance-lifecycle.md): the page's stage as this user sees it,
 * the stage the instance is in (its status), whether the workshop is live,
 * and navTo — which, when leaving Toteutus during a live workshop, tells the
 * next page so its live chip can say the workshop keeps going.
 */
export default function useStageNav({ instanceId, stages, pathname, onNavigate }) {
  const pageStage = getStageForPath(pathname);
  // A facilitator's Tulokset has Raportti only: take the user's own copy.
  const activeStage = pageStage && stages.find((stage) => stage.key === pageStage.key);
  const { instance } = useInstanceRecord(instanceId);
  const instanceStage = instance ? currentStage(instance.status) : null;
  const { chain } = useWorkshopChain(instanceId);
  const live = Boolean(chain?.live?.active);
  const { state } = useLocation();

  const navTo = useCallback((path) => {
    const target = getStageForPath(path.split('?')[0]);
    const leaving = live && activeStage?.key === 'run' && target?.key !== 'run';
    onNavigate(path, leaving ? { state: { leftLiveWorkshop: true } } : undefined);
  }, [live, activeStage, onNavigate]);

  return {
    activeStage,
    instanceStage,
    chain,
    live,
    justLeftLive: Boolean(state?.leftLiveWorkshop),
    navTo,
  };
}
